import { MessageCircle, MapPin, CirclePlay, Info } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function MobileQuickActions() {
  return <section data-section-id="225673" id="mobile-quick-actions" className="fixed right-6 bottom-6 z-50 flex flex-col gap-4 md:hidden bg-background text-foreground">
      <Link to="#" aria-label="Kirim Laporan">
        <Button size="icon" className="size-14 rounded-lg bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-110 hover:bg-primary/90 transition-all duration-300 [&_svg]:size-6 animate-in fade-in slide-in-from-bottom-4 duration-500 delay-200">
          <MapPin />
        </Button>
      </Link>

      <Link to="#" aria-label="Live Driver">
        <Button size="icon" className="size-14 rounded-lg bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-110 hover:bg-primary/90 transition-all duration-300 [&_svg]:size-6 animate-in fade-in slide-in-from-bottom-4 duration-500 delay-400">
          <CirclePlay />
        </Button>
      </Link>

      <Link to="#" aria-label="Info Razia">
        <Button size="icon" className="size-14 rounded-lg bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-110 hover:bg-primary/90 transition-all duration-300 [&_svg]:size-6 animate-in fade-in slide-in-from-bottom-4 duration-500 delay-600">
          <Info />
        </Button>
      </Link>
    </section>;
}